import { Box, Button } from "@mui/material";
import { Close, Pause, PlayArrow, RestartAlt, RestartAltRounded, Stop } from "@mui/icons-material";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { TestContext } from "../../context/test_context";
import LoadBox from "../global/LoadBox";
import { TestListContext, TestList } from "../../scenes/tests";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";


export default function TestButtonSet({ testgroup, setTestGroup }: any) {
  const {
    deleteTestGroup,
    pauseTestGroup,
    restartTestGroup,
    stopTestGroup,
    pauseLoading,
    restartLoading,
    stopLoading,
    deleteLoading
  } = useContext(TestContext);
  const navigate = useNavigate();
  const buttonStyle = {
    width: 100,
    mr: 1
    // my: { xs: 0, sm: 1, md: 0 },
    // backgroundColor: "#ff5757",
  };

  async function togglePlayPause(testgroup: any) {
    if (!testgroup) return; // Handle case where testgroup is still null
    console.log(`Paused: ${testgroup.id} with ${testgroup.active}`);
    const resp = await pauseTestGroup(testgroup.id);
    if (resp.success) {
      setTestGroup(resp.testgroup);
    }
  };

  async function toggleStop(testgroup: any) {
    if (!testgroup) return; // Handle case where testgroup is still null
    console.log(`Stopped: ${testgroup.id} with ${testgroup.finished}`);
    const resp = await stopTestGroup(testgroup.id);
    if (resp.success) {
      setTestGroup(resp.testgroup);
    }
  };

  async function toggleRestart(testgroup: any) {
    if (!testgroup) return; // Handle case where testgroup is still null
    console.log(`Restarted: ${testgroup.id} with ${testgroup.finished}`);
    const resp = await restartTestGroup(testgroup.id);
    if (resp.success) {
      setTestGroup(resp.testgroup);
    }
  };

  async function toggleDelete(testgroup: any) {
    if (!testgroup) return; // Handle case where testgroup is still null
    console.log(`Deleted: ${testgroup.id} with ${testgroup.finished}`);

    try {
      const resp = await deleteTestGroup(testgroup.id);
      if (resp.success && !testgroup.finished) {
        navigate("/tests");
      } else if (resp.success && testgroup.finished) {
        navigate("/finished");
      } else {
        alert("Delete Error");
      }
    } catch (error) {
      console.error("Error deleting test group:", error);
    }
  };

  if (!testgroup) {
    return <Box className={"h-6"}></Box>;
  }


  return (
    <Box
      sx={{
        display: "flex",
        // flexDirection: { xs: "row", sm: "column", md: "row" },
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center"
      }}
    >
      {!testgroup.finished ?
        <LoadingButton
          loading={pauseLoading}
          sx={buttonStyle}
          size={"medium"}
          variant="contained"
          onClick={() => togglePlayPause(testgroup)}
          startIcon={testgroup.active ? <Pause /> : <PlayArrow />}
          className={"ml-1"}
        >
          {testgroup.active ? "Pause" : "Play"}
        </LoadingButton> : <LoadingButton
          loading={restartLoading}
          sx={buttonStyle}
          size={"medium"}
          variant="contained"
          onClick={() => toggleRestart(testgroup)}
          startIcon={<RestartAlt />}
        >
          Restart
        </LoadingButton>}
      {!testgroup.finished &&
        <LoadingButton
          loading={stopLoading}
          sx={buttonStyle}
          size={"medium"}
          variant="contained"
          onClick={() => toggleStop(testgroup)}
          startIcon={<Stop />}
        >
          Stop
        </LoadingButton>}
      <Button
        sx={buttonStyle}
        size={"medium"}
        variant="contained"
        onClick={() => {
          if (
            window.confirm("Are you sure you want to delete this test group?")
          ) {
            toggleDelete(testgroup);
          }
        }}
        startIcon={<Close />}
        // disabled={None}
      >
        Delete
      </Button>
    </Box>
  );
}
